<template>
  <div class="btn-group p-1">
    <WebcamRecorderIncreaseScaleButton />
    <WebcamRecorderDecreaseScaleButton />
  </div>
</template>

<script>
import WebcamRecorderDecreaseScaleButton from './webcam-recorder-decrease-scale-button.vue'
import WebcamRecorderIncreaseScaleButton from './webcam-recorder-increase-scale-button.vue'

export default {
  name: 'WebcamRecorderTransformControls',
  components: { WebcamRecorderDecreaseScaleButton, WebcamRecorderIncreaseScaleButton },
}
</script>
